import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import 'react-dates/initialize';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';

import 'react-dates/lib/css/_datepicker.css';

import s from './styles.module.scss';

class DatePicker extends PureComponent {
  static propTypes = {
    /** Style input with error */
    meta: PropTypes.shape({
      error: PropTypes.string,
      touched: PropTypes.bool,
    }),
    placeholder: PropTypes.string,
    /** Initial or/and picked value */
    value: PropTypes.objectOf(PropTypes.any),
  };

  static defaultProps = {
    meta: {
      error: undefined,
      touched: false,
    },
    value: undefined,
    placeholder: '',
  };

  state = {
    focused: false,
  };

  onFocusChange = ({ focused }) => {
    this.setState({ focused });
  };

  render() {
    const { focused } = this.state;
    const {
      meta: { error, touched },
      placeholder,
      ...rest
    } = this.props;
    const { onChange, value } = rest.input;
    const isOutsideRange = () => false;

    return (
      <div className={cx(s.root, { [s.error]: error && touched })}>
        <SingleDatePicker
          isOutsideRange={isOutsideRange}
          placeholder={placeholder}
          onDateChange={onChange}
          date={value ? moment(value) : null}
          focused={focused}
          hideKeyboardShortcutsPanel
          inputIconPosition="after"
          numberOfMonths={1}
          onFocusChange={this.onFocusChange}
          showDefaultInputIcon
        />
        {error && touched && <div className={s.errorMessage}>{error}</div>}
      </div>
    );
  }
}

export default DatePicker;
